/**
 * Build-time provenance for the user app bundle (injected by Vite `define` + static `build-info.json`).
 * Values are fixed at `vite build`; they are not runtime client clocks.
 */
export type AppBuildProvenance = {
  ok: true;
  app: 'orrekie-app';
  environment: string;
  gitSha: string;
  buildTime: string;
  source: 'vite-build';
};

export function getAppBuildProvenance(): AppBuildProvenance {
  return {
    ok: true,
    app: 'orrekie-app',
    environment: import.meta.env.VITE_APP_ENVIRONMENT ?? 'unknown',
    gitSha: import.meta.env.VITE_BUILD_SHA ?? 'unknown',
    buildTime: import.meta.env.VITE_BUILD_TIME ?? 'unknown',
    source: 'vite-build',
  };
}
